
<div id="contextMenu1" class="dropdown">
  <button id="contextMenuBtn" type="button" class="inm-button dropbtn">{{buttonText}}</button>
  <div *ngIf="show" class="dropdown-content">
    <a 
      *ngFor="let item of menuItems" 
      (click)="itemClicked(item.Name)">{{item.Label}}
    </a>
  </div>
</div>